import StatsCard from "../../../components/stats-card";
import { FiThermometer } from "react-icons/fi";

export default function TemperatureMonitoringCard({
  styles,
  onOpen,
  branchListError,
  roleId,
  userBranchCode,
  fullTempRows,
  getTempClass,
}) {
  return (
    <StatsCard
      title="Temperature Monitoring"
      className={styles.tempMonitoringCard}
      onClick={onOpen}
    >
      <span className={styles.tempCardIcon} aria-hidden>
        <FiThermometer size={24} />
      </span>
      <div className={styles.cardHintRow}>
        <span className={styles.cardHintText}>Click to view details</span>
      </div>

      {branchListError && (
        <p className="text-red-500 text-xs mt-1">{branchListError}</p>
      )}

      {roleId !== 2 && !userBranchCode && (
        <p className="text-red-500 text-xs mt-1">No branch assigned to your user</p>
      )}

      <ul className={styles.tempList}>
        {fullTempRows.length === 0 ? (
          <li className={styles.tempEmpty}>No temperature data</li>
        ) : (
          fullTempRows.slice(0, 3).map((row) => (
            <li
              key={row.branchcode || row.branchname}
              className={styles.tempItem}
              title={row.branchcode ? `Branch code: ${row.branchcode}` : undefined}
            >
              <span className={getTempClass(row.status)}>{row.temp}°C</span>
              <span className={styles.tempBranchName}>{row.branchname}</span>
            </li>
          ))
        )}
      </ul>
    </StatsCard>
  );
}
